import React from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import object2 from "../../../Assets/img/OBJECTS (2).svg";
import tick from "../../../Assets/img/tick.svg";
import cross from "../../../Assets/img/cross.svg";
import autoattend from "../../../Assets/img/auto_attend_logo.png";
import hastag from "../../../Assets/img/logo_hastag.png";
import PuzzlerTalk from "../../Components/LandingPage/PuzzlerTalk";

function Rules() {
  return (
    <div className="Rules innerBody">
      <Header />
      <div className="container">
        <div className="row">
          <h3 className="title m-auto pt-4 pb-4">RULES</h3>
        </div>
      </div>
      <div className="container how-to pt-5 pb-5">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-12 rules_points">
            <div>
              1 ) &nbsp; The Puzzled gameplay involves getting to the successive
              levels by whatever means necessary. There are three primary
              methods (there might be more as well ;)) by which you can progress
              through levels:
              <ul>
                <li>Entering the correct answer in the answer box provided</li>
                <li>Changing the URL in the address bar</li>
                <li>Clicking on various objects on the page</li>
              </ul>
            </div>
            <p>
              2 ) &nbsp; Answers are not case sensitive. In case the answer
              contains more than one word, you should include spaces between
              words when entering the answer. Also, no special characters are
              part of any answer.
            </p>
            <p>
              3 ) &nbsp; Most levels will require some amount of lateral
              thinking combined with some help from Google (or your other
              favorite search engine). Images might also need to be
              reverse-searched using Google/Tineye.
            </p>
            <div>
              4 ) &nbsp; In each level, clues can be found in different places,
              like:
              <ul>
                <li>Page Title</li>
                <li>URL name</li>
                <li>Pictures on the level (and their names!)</li>
                <li>Page source. (Right click and use View Page Source)</li>
                <li>
                  Some amount of binary (.doc, .jpg etc.) download/manipulation
                  may be required to get the hint to next level
                </li>
              </ul>
              Please note: Not every one of these might be a clue. We promise to
              make a conscious effort to mislead you!
            </div>
            <p>
              5 ) &nbsp; Whenever in doubt, you can post your questions to the
              moderators in the in-level Disqus forums. Please avoid posting
              explicit clues, as it might help your competitors cross the levels
              faster than you. Our mods <b>Heisenberg</b> and{" "}
              <b>The Professor</b> will be around most of the time to respond to
              you. In rare times where both of them doze off, or are off to have
              a beer, you might need to wait for your reply patiently. As the
              level difficulty increases, so does our reluctance to give out
              obvious clues. In case we find many players to be stuck at certain
              levels, a blatant push might be provided from our end. But the
              later levels of the game are designed in such a way that players
              will have to spend some time wrapping their head around the clues,
              rather than expect the same to be solved in a matter of minutes.
            </p>
          </div>
          <div className="col-lg-6 col-md-12 col-12">
            <img src={object2} className="left-object" alt="" />
          </div>
        </div>
        <div className="row d-flex justify-content-center mt-5 do_s">
          <div className="yellow-box p-3 mt-3">
            <h4 className="text-center pb-3 pt-1">Do’S</h4>
            <ul className="list-unstyled pl-2 mt-2">
              <li className="d-flex align-items-start">
                <img src={tick} alt="" className="pt-2" />
                <div className="col">
                  We have observed, based on past experiences, that in spite of
                  getting the right answers, players refuse to enter them and
                  try them out! We have no restrictions on the number of
                  attempts, so please enter whatever you feel is the answer.
                </div>
              </li>
              <li className="d-flex align-items-start mt-2">
                <img src={tick} alt="" className="pt-2" />
                <div className="col">
                  Please use the comments section we have provided on each
                  level, to post your queries about the level to us. One of our
                  moderators will respond to your questions at the earliest.
                </div>
              </li>
              <li className="d-flex align-items-start">
                <img src={tick} alt="" className="pt-2" />
                <div className="col">
                  Puzzled is more fun when played with a group of puzzle
                  enthusiasts. So try to form a team, which will help you solve
                  the levels quickly. Puzzled is one good example where too many
                  cooks actually do not spoil the broth.
                </div>
              </li>
              <li className="d-flex align-items-start mt-2">
                <img src={tick} alt="" className="pt-2" />
                <div className="col">
                  Attention to detail becomes very important when you play
                  Puzzled. So, try to spend good time analyzing all elements in
                  the level before posting in the comments section. Remember,
                  clues you give out in the comments section makes your
                  competitor solve the level and catch you up!
                </div>
              </li>
            </ul>
          </div>
          <div className="yellow-box p-3 ml-4 mt-3">
            <h4 className="text-center pb-3 pt-1">Dont’S</h4>
            <ul className="list-unstyled pl-2 mt-2">
              <li className="d-flex align-items-start">
                <img src={cross} alt="" className="pt-2" />
                <div className="col">
                  Please do not share the answers on personal blogs/websites or
                  other forums. It is quite possible that the other person may
                  finish before you
                </div>
              </li>
              <li className="d-flex align-items-start mt-2">
                <img src={cross} alt="" className="pt-2" />
                <div className="col">
                  We, at Puzzled believe strongly in a Fair Game. So clues, if
                  any will only be given out in our official website/social
                  media. We will not entertain personal messages to the
                  organizers for hints/answers. So do not attempt the same.
                </div>
              </li>
              <li className="d-flex align-items-start">
                <img src={cross} alt="" className="pt-2" />
                <div className="col">
                  Do not try to brute force our servers in an attempt to solve
                  the levels. We will have to penalize players who resort to
                  unethical means of solving a level.
                </div>
              </li>
              <li className="d-flex align-items-start mt-2">
                <img src={cross} alt="" className="pt-2" />
                <div className="col">
                  Do not blame us if we caused:
                  <ul>
                    <li>Sleep Deprivation</li>
                    <li>Hair Loss</li>
                    <li>Breakups</li>
                    <li>Job termination</li>
                    <li>
                      Or any other damage to your personal/professional life.
                    </li>
                  </ul>
                  You should know what you are getting into, before starting the
                  game!
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container-fluid bg-base">
        <div className="container">
          <div className="row">
            <div className="col pl-0 pr-0">
              <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                <div className="position-relative  flex-column flex-md-row align-items-center">
                  <div className="h3 text-center mb-md-0">
                    <span>Are you up for the challenge ?</span> Sign up now and
                    start cracking!{" "}
                    <a href="/register" className="btn btn-lg btn-yellow ml-5">
                      REGISTER
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-powered-by pt-4 pb-4">
        <div className="container">
          <div className="row text-center">
            <h3 className="ml-auto mr-auto">POWERED BY</h3>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6 col-md-12 col-12 pb-4">
              <h4>They make us run this game</h4>
              <p>
                The generous contributions of our corporate sponsors give us the
                ability to do so much more. These businesses and organizations
                find value in our work and support us. If you would like to
                sponsor, do get in touch.
              </p>

              <div className="text-left sponsor_buttons">
                <a href="/become-sponsor" className="btn btn-yellow mt-3">
                  {" "}
                  BECOME A SPONSOR{" "}
                </a>

                <a
                  href="/corporate-puzzled"
                  className="btn btn-yellow mt-3 ml-4"
                  style={{ padding: "7PX 28PX" }}
                >
                  {" "}
                  HOST AN EVENT{" "}
                </a>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12 powered_by pb-4">
              <div className="container">
                <div className="row">
                  <div className="col-4 offset-2">
                    <a
                      href="https://autoattend.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <img src={autoattend} alt="" />{" "}
                    </a>
                  </div>
                  <div className="col-4">
                    <a
                      href="https://www.hashtagtechnologies.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <img src={hastag} alt="" />{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-testimonial ">
        <div className="container">
          <PuzzlerTalk />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Rules;
